"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isMap(candidate) {
    return (candidate && (typeof candidate.has === 'function') && (typeof candidate.get === 'function'));
}
exports.isMap = isMap;
